<template>
  <div class="row">
    <div class="col-md-12">
      <hr class="mt-0 mb-2 horizontal-line">
      <h5>{{ $t('Session') }}</h5>
      <template>
        <div class="row" v-for="(date, index) in model.dates"
             :key="`date_${index}`">
          <div class="col-lg-3">
            <input-widget :disabled="disabled" :model="date" attribute="start_date" type="datepicker" :min="getCurrentDate"/>
          </div>
          <div class="col-lg-3">
            <input-widget :disabled="disabled" :model="date" attribute="start_time" type="timepicker"/>
          </div>
          <div class="col-lg-3">
            <input-widget :disabled="disabled" :model="date" attribute="end_date" type="datepicker" :min="getCurrentDate"/>
          </div>
          <div class="col-lg-3">
            <input-widget :disabled="disabled" :model="date" attribute="end_time" type="timepicker"/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import {SYSTEM_DATE_FORMAT} from "../../../core/services/formatter.service";
  import BaseModel from "../../../core/components/input-widget/BaseModel";

  export default {
    name: "SessionSection",
    components: {InputWidget},
    props: {
      model: BaseModel,
      disabled: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      getCurrentDate() {
        return this.$options.filters.toDate(new Date(), SYSTEM_DATE_FORMAT)
      },
    },
  }
</script>

<style lang="scss" scoped>
  /deep/ .horizontal-line {
    font-weight: 800;
  }
</style>